export const getDateRangeBefore = (
    end: Date,
    dateOffset: DateOffset,
): { start: Date; end: Date } => {
    let dateOffsetMs = 0;

    const { seconds, minutes, hours, days } = dateOffset;

    if (seconds) {
        dateOffsetMs += seconds * 1000;
    }

    if (minutes) {
        dateOffsetMs += minutes * 60 * 1000;
    }

    if (hours) {
        dateOffsetMs += hours * 60 * 60 * 1000;
    }

    if (days) {
        dateOffsetMs += days * 24 * 60 * 60 * 1000;
    }

    const start = new Date();

    start.setTime(end.getTime() - dateOffsetMs);

    return {
        start,
        end,
    };
};
